import { render, staticRenderFns } from "./adminOrdersDashboard.vue?vue&type=template&id=0efd0392&scoped=true"
import script from "./adminOrdersDashboard.vue?vue&type=script&lang=js"
export * from "./adminOrdersDashboard.vue?vue&type=script&lang=js"
import style0 from "./adminOrdersDashboard.vue?vue&type=style&index=0&id=0efd0392&prod&lang=scss&scoped=true"
import style1 from "./adminOrdersDashboard.vue?vue&type=style&index=1&id=0efd0392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efd0392",
  null
  
)

export default component.exports